import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute  } from '@angular/router';
import { FormControl } from '@angular/forms';
import { AuthService } from '../../data-access/auth.service';
import {environment} from "../../../../environments/environment";
import {faTriangleExclamation} from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'loginForm',
    templateUrl: './loginForm.html',
    standalone: false
})
export class LoginFormComponent implements OnInit {
  email = new FormControl('');
  password = new FormControl('');
  formDivStyle = `display: flex; flex-direction: column; align-items: center; gap: 3rem; border-width: 2px; border-radius: 0.5rem; border-color: ${localStorage.getItem('primaryColor')}; background: #E5E8EB; width: 50%; padding: 2rem;`
  email_saml_attribute_missing = false

  errors: { emailError: string; passwordError: string } = {
    emailError: '',
    passwordError: '',
  };

  errorMessage: string | null = null;

  constructor(private authService: AuthService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {
    // TODO check if its the local fullstack development
    const querystring = window.location.hash.substring(1);
    const access_token = new URLSearchParams(querystring).get('access_token');

    const code = this.route.snapshot.queryParamMap.get('code');

    if(code != null) {
      this.authService.getTokens(code).subscribe((response: any) => {
        this.authService.setToken(response.access_token)
        this.authService.setRefreshToken(response.refresh_token);
        this.authService.user$.subscribe({
          next: (data) => {
            if (data.success == false) {
              this.authService.fixLogin().subscribe((response) => {
                if(response.success) {
                  this.router.navigate(['/dashboard']);
                } else {
                  localStorage.removeItem('token');
                  this.errorMessage = 'You do not have an account set up yet. Please contact our support team to request one.';
                }
              })
            }
            else {
              this.router.navigate(['/dashboard']);
            }
          },
          error: (err) => {
            this.router.navigate(['/login']);
          },
        });
      })
    }

    this.email_saml_attribute_missing = this.route.snapshot.fragment != null && this.route.snapshot.fragment.includes('error_description=invalid+SAML+response+received+Invalid+user+attributes+email:+The+attribute+is+required')

    /*if (access_token) {
      this.authService.setToken(access_token);
      this.authService.user$.subscribe({
        next: (data) => {
          if (data.success == false) {
            this.authService.fixLogin().subscribe((response) => {
              if(response.success) {
                this.router.navigate(['/dashboard']);
              } else {
                localStorage.removeItem('token');
                this.errorMessage = 'You do not have an account set up yet. Please contact our support team to request one.';
              }
            })
          }
          else {
            this.router.navigate(['/dashboard']);
          }
        },
        error: (err) => {
          this.router.navigate(['/login']);
        },
      });
    }*/
    if(environment.__auth_email != null) {
      localStorage.setItem('__auth_email', environment.__auth_email);
    } else {
      localStorage.removeItem('__auth_email');
    }
  }

  emailLogin() {
    // More of a placeholder and better validation should be done
    // TODO: Add better validation
    if (this.email.value && this.password.value) {
      this.authService.emailLogin(this.email.value, this.password.value);
    }
  }

  netIDLogin() {
    this.authService.netIDLogin();
  }

  protected readonly localStorage = localStorage;
  protected readonly faTriangleExclamation = faTriangleExclamation;
}
